/**
 * Hierarchy Settings Tab Component
 */
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import { Building2, Factory } from 'lucide-react';
import { OrgChartView } from '../../orgchart';

export function HierarchyTab() {
  return (
    <div className="space-y-4">
      <Tabs defaultValue="suppliers" className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-4">
          <TabsTrigger value="suppliers">
            <Building2 className="h-4 w-4 mr-2" />
            Suppliers
          </TabsTrigger>
          <TabsTrigger value="customers">
            <Factory className="h-4 w-4 mr-2" />
            Customers
          </TabsTrigger>
        </TabsList>

        <TabsContent value="suppliers">
          <OrgChartView companyType="supplier" />
        </TabsContent>

        <TabsContent value="customers">
          <OrgChartView companyType="customer" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
